import {
  chakraComponents,
  type ClearIndicatorProps,
  type GroupBase,
  type MultiValueRemoveProps,
} from "chakra-react-select";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useTranslatedSelectButtons = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>() => {
  const { t } = useTranslation();
  return useMemo(() => {
    const clearLabel = t("Clear selection");
    const ClearIndicator = (props: ClearIndicatorProps<Option, IsMulti, Group>) => (
      <chakraComponents.ClearIndicator {...props} innerProps={{ ...props.innerProps, "aria-label": clearLabel }} />
    );
    const MultiValueRemove = (props: MultiValueRemoveProps<Option, IsMulti, Group>) => (
      <chakraComponents.MultiValueRemove
        {...props}
        innerProps={{
          ...props.innerProps,
          "aria-label": t("Remove {{label}}", { label: props.selectProps.getOptionLabel(props.data) }),
        }}
      />
    );
    return { ClearIndicator, MultiValueRemove };
  }, [t]);
};
